import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @author weiztang
 * @version 0.0.1
 * @date 2022.08.08
 * @class biz/mobileShare/arkShare
 */
import loader from '../../common/loader';
import Request from '../../common/network';
import ATM from '../../util/atm';
import { getGameId } from '../login/common';
var qqapi_url = 'https://open.mobile.qq.com/sdk/qqapi.wk.js?_bid=152';
var arkShare = {
  defopt: {
    /**
         * @cfg {string} app arkid
         */
    app: 'com.tencent.game',

    /**
         * @cfg {string} view ark 视图
         */
    view: 'news',
    title: '腾讯游戏Milo手Q分享默认标题title',
    desc: 'Milo QQ Ark默认分享详情信息desc',
    jumpUrl: 'https://milo.qq.com',
    preview: 'https://ossweb-img.qq.com/images/milo/logo/milo.png',
    tag: '腾讯游戏',
    tagIcon: 'https://ossweb-img.qq.com/images/milo/logo/game.png',
    ver: '0.0.0.1',
    prompt: '腾讯游戏Ark分享默认提示_Powered by Milo Team',
    successCallback: null,
    failCallback: null
  },
  init: function init(opt) {
    var _self = this;

    this.defopt = _objectSpread(_objectSpread({}, this.defopt), opt);

    var setInfo = function setInfo() {
      mqq.data.setShareInfo({
        share_url: _self.defopt.jumpUrl,
        title: _self.defopt.title,
        desc: _self.defopt.desc,
        image_url: _self.defopt.preview,
        source_name: _self.defopt.tag
      }, function () {});
      mqq.ui.setOnShareHandler(function (e) {
        console.log('[Milo Core 用户触发分享方式]', e);

        if (e == 0) {
          _self.share(opt);
        } else {
          mqq.ui.shareMessage({
            title: _self.defopt.title,
            desc: _self.defopt.desc,
            share_type: e,
            share_url: _self.defopt.jumpUrl,
            image_url: _self.defopt.preview,
            back: true
          }, function () {});
        }
      });
    }; // 设置默认数据 add by weiztang 20221103


    if (window.mqq) {
      setInfo();
    } else {
      loader.loadScript({
        sRefresh: 0,
        url: qqapi_url
      }).then(function () {
        setInfo();
      });
    }
  },
  share: function share(opt) {
    // 修复触发手Q分享后导致微信分享失败的问题
    var _self = this;

    this.defopt = _objectSpread(_objectSpread({}, this.defopt), opt);

    var execArk = function execArk() {
      if (parseInt(mqq.compare('8.8.93')) > 0) {
        // 高版本支持
        var meta = {
          news: {
            title: _self.defopt.title,
            desc: _self.defopt.desc,
            jumpUrl: _self.defopt.jumpUrl,
            preview: _self.defopt.preview,
            tag: _self.defopt.tag,
            tagIcon: _self.defopt.tagIcon
          }
        }; // 签名用的数据结构

        var arkData = {
          app: _self.defopt.app,
          view: 'news',
          meta: meta,
          ver: _self.defopt.ver,
          prompt: _self.defopt.prompt
        }; // 发起签名

        Request.ajax({
          url: 'https://ams.game.qq.com/arksign/v1',
          type: 'POST',
          datatype: 'json',
          xhrFields: {
            withCredentials: true
          },
          data: {
            content: encodeURIComponent(JSON.stringify(arkData))
          },
          success: function success(data) {
            console.log('[Milo Core aciResponse]', data);
            var oData = data; // try {
            //   oData = JSON.parse(data);
            // } catch (e) {
            //   console.log('aciResultParseFail:', e);
            // }

            if (oData && oData.code == 0) {
              var TokenParms = null;

              try {
                TokenParms = JSON.parse(oData.data);
              } catch (e) {
                console.log('[Milo Core aciTokenAndCtimeFail]', e);
              }

              if (TokenParms) {
                var _TokenParms = TokenParms,
                    token = _TokenParms.token;
                var ctime = parseInt(TokenParms.ctime);

                if (token && ctime) {
                  var appConfig = {
                    ctime: ctime,
                    token: token,
                    autosize: 0,
                    forward: 1
                  };
                  var invokeData = {
                    appName: _self.defopt.app,
                    appView: 'news',
                    metaData: JSON.stringify(meta),
                    appConfig: JSON.stringify(appConfig),
                    appMinVersion: _self.defopt.ver,
                    promptText: _self.defopt.prompt
                  };
                  console.log('[Milo Core invokeData]', invokeData);
                  mqq.invoke('QQApi', 'shareArkMessageSafe', invokeData, function (data) {
                    // 0：用户点击发送，完成整个分享流程
                    // 1：缺少必填参数
                    // 2：appName不在白名单内
                    // 3：参数格式错误(json格式错误)
                    // 4：用户点击取消，中断分享流程
                    console.log('[Milo Core arkCallback]', data);
                    _self.defopt.successCallback && _self.defopt.successCallback(data);
                  });
                }
              } // 增加成功ATM上报


              try {
                ATM.reportATM({
                  toappid: 1,
                  tomoduletype: 70,
                  tointer: 2,
                  toreturncode: 0,
                  businesstype: getGameId(),
                  result: 0,
                  cgi: location.href,
                  errormsg: oData.message
                });
              } catch (error) {
                console.log(error);
              }
            } else {
              _self.defopt.failCallback && _self.defopt.failCallback(oData); // 增加失败ATM上报

              try {
                ATM.reportATM({
                  toappid: 1,
                  tomoduletype: 70,
                  tointer: 2,
                  toreturncode: oData.code,
                  businesstype: getGameId(),
                  result: oData.code,
                  cgi: location.href,
                  errormsg: oData.message
                });
              } catch (error) {
                console.log(error);
              }
            }
          },
          error: function error() {
            _self.defopt.failCallback && _self.defopt.failCallback({
              code: -99,
              message: 'network error'
            });
          }
        });
      } else {
        if (_self.defopt.failCallback) {
          _self.defopt.failCallback({
            code: -8893,
            message: '如需分享，请升级手Q至最新版本！'
          });
        } else {
          alert('如需分享，请升级手Q至最新版本！');
        }
      }
    };

    if (window.mqq) {
      execArk();
    } else {
      loader.loadScript({
        sRefresh: 0,
        url: qqapi_url
      }).then(function () {
        execArk();
      });
    }
  },
  pic: function pic(opt) {
    var _self = this;

    var execArk = function execArk() {
      if (parseInt(mqq.compare('8.8.93')) > 0) {
        // 高版本支持
        var meta = {
          pic: {
            jumpUrl: opt.jumpUrl ? opt.jumpUrl : _self.defopt.jumpUrl,
            preview: opt.preview ? opt.preview : _self.defopt.preview,
            tag: opt.tag ? opt.tag : _self.defopt.tag,
            tagIcon: opt.tagIcon ? opt.tagIcon : _self.defopt.tagIcon
          }
        }; // 签名用的数据结构

        var arkData = {
          app: _self.defopt.app,
          view: 'pic',
          meta: meta,
          ver: _self.defopt.ver,
          prompt: opt.prompt ? opt.prompt : _self.defopt.prompt
        }; // 发起签名

        Request.ajax({
          url: 'https://ams.game.qq.com/arksign/v1',
          type: 'POST',
          datatype: 'json',
          xhrFields: {
            withCredentials: true
          },
          data: {
            content: encodeURIComponent(JSON.stringify(arkData))
          },
          success: function success(data) {
            console.log('[Milo Core pic aciResponse]', data);
            var oData = data; // try {
            //   oData = JSON.parse(data);
            // } catch (e) {
            //   console.log('aciResultParseFail:', e);
            // }

            if (oData && oData.code == 0) {
              var TokenParms = null;

              try {
                TokenParms = JSON.parse(oData.data);
              } catch (e) {
                console.log('[Milo Core pic aciTokenAndCtimeFail]', e);
              }

              if (TokenParms) {
                var _TokenParms2 = TokenParms,
                    token = _TokenParms2.token;
                var ctime = parseInt(TokenParms.ctime);

                if (token && ctime) {
                  var appConfig = {
                    ctime: ctime,
                    token: token,
                    autosize: 0,
                    forward: 1
                  };
                  var invokeData = {
                    appName: _self.defopt.app,
                    appView: 'pic',
                    metaData: JSON.stringify(meta),
                    appConfig: JSON.stringify(appConfig),
                    appMinVersion: _self.defopt.ver,
                    promptText: opt.prompt ? opt.prompt : _self.defopt.prompt
                  };
                  console.log('[Milo Core pic invokeData]', invokeData);
                  mqq.invoke('QQApi', 'shareArkMessageSafe', invokeData, function (data) {
                    // 0：用户点击发送，完成整个分享流程
                    // 1：缺少必填参数
                    // 2：appName不在白名单内
                    // 3：参数格式错误(json格式错误)
                    // 4：用户点击取消，中断分享流程
                    console.log('[Milo Core pic arkCallback]', data);
                    opt.successCallback && opt.successCallback(data);
                  });
                }
              } // 增加成功ATM上报


              try {
                ATM.reportATM({
                  toappid: 1,
                  tomoduletype: 70,
                  tointer: 2,
                  toreturncode: 0,
                  businesstype: getGameId(),
                  result: 0,
                  cgi: location.href,
                  errormsg: oData.message
                });
              } catch (error) {
                console.log(error);
              }
            } else {
              opt.failCallback && opt.failCallback(oData); // 增加失败ATM上报

              try {
                ATM.reportATM({
                  toappid: 1,
                  tomoduletype: 70,
                  tointer: 2,
                  toreturncode: oData.code,
                  businesstype: getGameId(),
                  result: oData.code,
                  cgi: location.href,
                  errormsg: oData.message
                });
              } catch (error) {
                console.log(error);
              }
            }
          },
          error: function error() {
            opt.failCallback && opt.failCallback({
              code: -99,
              message: 'network error'
            });
          }
        });
      } else {
        if (opt.failCallback) {
          opt.failCallback({
            code: -8893,
            message: '如需分享，请升级手Q至最新版本！'
          });
        } else {
          alert('如需分享，请升级手Q至最新版本！');
        }
      }
    };

    if (window.mqq) {
      execArk();
    } else {
      loader.loadScript({
        sRefresh: 0,
        url: qqapi_url
      }).then(function () {
        execArk();
      });
    }
  }
};
export default arkShare;